import ChatPaymentStats from "./ChatPaymentStats";
import AthletePaymentStates from "./AthletePaymentStates";
import RefundsStates from "./RefundsStates";
import GetAllManagers from "./GetAllManagers";
import GetManager from "./GetManager";
import DeleteSchoolAdminContract from "./DeleteSchoolAdminContract";
import AdminMonthalyEarningsByYear from "./AdminMonthalyEarningsByYear";
import GetFanStates from "./GetFanStates";
import BidRepository from "./BidRepository";
import GetManagerEarnings from "./GetManagerEarnings";
import GetUnRegisteredColleges from "./GetUnRegisteredColleges";
import GetUnRegisteredSchools from "./GetUnRegisteredSchools";
import FetchCoinsRepository from "./FetchCoinsRepository";

const repositories = {
  adminStates: ChatPaymentStats,
  athleteStates: AthletePaymentStates,
  RefundsStates: RefundsStates,
  getAllManagers: GetAllManagers,
  getManager: GetManager,
  deleteContract: DeleteSchoolAdminContract,
  adminAllMonthEaringsByYear: AdminMonthalyEarningsByYear,
  fanStats: GetFanStates,
  bid: BidRepository,
  managerEarnings: GetManagerEarnings,
  unRegisterColleges: GetUnRegisteredColleges,
  unRegisterSchools: GetUnRegisteredSchools,
  getCoinsStats: FetchCoinsRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
